import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box, List, ListItemButton, ListItemIcon, ListItemText,
  Collapse, Tooltip, Typography, Divider, Avatar, IconButton
} from '@mui/material';
import {
  Dashboard, TrendingUp, NotificationsActive, SmartToy,
  BugReport, WbSunny, Science, Agriculture, Opacity,
  Satellite, ShoppingCart, Storefront, Assignment,
  Security, AccountBalance, Park, Handshake,
  MenuBook, People, Policy, ExpandLess, ExpandMore,
  LocalAtm, VerifiedUser, Build, ShowChart, WaterDrop,
  Timeline, EmojiEvents, MoreVert, ChevronLeft, ChevronRight,
  WorkspacePremium, Groups,
} from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

// Map route path → TRANSLATIONS.nav key
const PATH_NAV_KEY = {
  '/dashboard':          'dashboard',
  '/prices':             'prices',
  '/prices/alerts':      'prices',
  '/live-prices':        'prices',
  '/chat':               'aiChat',
  '/crop-doctor':        'cropDoctor',
  '/crop-doctor/history':'cropDoctor',
  '/weather':            'weather',
  '/soil':               'soilHealth',
  '/soil/new':           'soilHealth',
  '/advisory':           'advisory',
  '/schemes':            'schemes',
  '/profile':            'profile',
};

const PRIMARY = '#2E7D32';
const PRIMARY_DARK = '#1B5E20';
const PRIMARY_BG = '#E8F5E9';
const ACTIVE_BG = 'linear-gradient(135deg, rgba(46,125,50,0.15) 0%, rgba(76,175,80,0.08) 100%)';

const NAV_GROUPS = [
  {
    label: 'MAIN',
    items: [
      { label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: <Dashboard fontSize="small" />, path: '/dashboard' },
      { label: 'Profile', labelHi: 'प्रोफाइल', icon: <VerifiedUser fontSize="small" />, path: '/profile' },
      { label: 'Upgrade Plans', labelHi: 'प्लान अपग्रेड', icon: <WorkspacePremium fontSize="small" />, path: '/plans' },
    ]
  },
  {
    label: 'PRICES & MARKET',
    items: [
      { label: 'Mandi Prices', labelHi: 'मंडी भाव', icon: <TrendingUp fontSize="small" />, path: '/prices' },
      { label: 'Price Alerts', labelHi: 'भाव अलर्ट', icon: <NotificationsActive fontSize="small" />, path: '/prices/alerts' },
      { label: 'Market Intelligence', labelHi: 'बाज़ार बुद्धि', icon: <ShowChart fontSize="small" />, path: '/market-intelligence' },
      { label: 'Market Tools', labelHi: 'मार्केट टूल्स', icon: <NotificationsActive fontSize="small" />, path: '/market-tools' },
    ]
  },
  {
    label: 'INTELLIGENCE',
    items: [
      { label: 'Decision Engine', labelHi: 'निर्णय इंजन', icon: <LocalAtm fontSize="small" />, path: '/decision-engine' },
      { label: 'Crop Intelligence', labelHi: 'फसल बुद्धि', icon: <Agriculture fontSize="small" />, path: '/crop-intelligence' },
      { label: 'Yield Gap', labelHi: 'उपज अंतर', icon: <Timeline fontSize="small" />, path: '/yield-gap' },
      { label: 'Water Center', labelHi: 'जल केंद्र', icon: <WaterDrop fontSize="small" />, path: '/water' },
      { label: 'Scheme Maximizer', labelHi: 'योजना लाभ', icon: <EmojiEvents fontSize="small" />, path: '/scheme-maximizer' },
      { label: 'Encyclopedia', labelHi: 'फसल ज्ञान', icon: <MenuBook fontSize="small" />, path: '/encyclopedia' },
    ]
  },
  {
    label: 'AI TOOLS',
    items: [
      { label: 'AI Assistant', labelHi: 'AI सहायक', icon: <SmartToy fontSize="small" />, path: '/chat' },
      { label: 'Crop Doctor', labelHi: 'फसल डॉक्टर', icon: <BugReport fontSize="small" />, path: '/crop-doctor' },
      { label: 'Weather', labelHi: 'मौसम', icon: <WbSunny fontSize="small" />, path: '/weather' },
      { label: 'Soil Health', labelHi: 'मिट्टी', icon: <Science fontSize="small" />, path: '/soil' },
      { label: 'Crop Advisory', labelHi: 'फसल सलाह', icon: <Agriculture fontSize="small" />, path: '/advisory' },
      { label: 'Yield Prediction', labelHi: 'उपज अनुमान', icon: <LocalAtm fontSize="small" />, path: '/yield' },
      { label: 'Irrigation', labelHi: 'सिंचाई', icon: <Opacity fontSize="small" />, path: '/irrigation' },
      { label: 'Satellite View', labelHi: 'सैटेलाइट', icon: <Satellite fontSize="small" />, path: '/satellite' },
      { label: 'Climate Risk', labelHi: 'जलवायु जोखिम', icon: <WbSunny fontSize="small" />, path: '/climate-risk' },
    ]
  },
  {
    label: 'MARKETPLACE',
    items: [
      { label: 'Buy Inputs', labelHi: 'इनपुट खरीदें', icon: <ShoppingCart fontSize="small" />, path: '/marketplace/buy' },
      { label: 'Sell Produce', labelHi: 'उपज बेचें', icon: <Storefront fontSize="small" />, path: '/marketplace/sell' },
      { label: 'Equipment Rental', labelHi: 'उपकरण किराया', icon: <Build fontSize="small" />, path: '/rental' },
      { label: 'Contracts', labelHi: 'अनुबंध', icon: <Assignment fontSize="small" />, path: '/marketplace/contracts' },
      { label: 'My Orders', labelHi: 'मेरे ऑर्डर', icon: <ShoppingCart fontSize="small" />, path: '/orders' },
    ]
  },
  {
    label: 'FINANCIAL',
    items: [
      { label: 'Crop Insurance', labelHi: 'फसल बीमा', icon: <Security fontSize="small" />, path: '/insurance' },
      { label: 'Farm Loans', labelHi: 'कृषि ऋण', icon: <AccountBalance fontSize="small" />, path: '/loans' },
      { label: 'Carbon Credits', labelHi: 'कार्बन', icon: <Park fontSize="small" />, path: '/carbon' },
      { label: 'Farm P&L', labelHi: 'खेत P&L', icon: <LocalAtm fontSize="small" />, path: '/farm-pl' },
    ]
  },
  {
    label: 'COMMUNITY',
    items: [
      { label: 'Farmer Forum', labelHi: 'किसान मंच', icon: <People fontSize="small" />, path: '/community' },
      { label: 'Kisan Community', labelHi: 'समुदाय + FPO', icon: <Groups fontSize="small" />, path: '/community-hub' },
      { label: 'Expert Connect', labelHi: 'विशेषज्ञ', icon: <Handshake fontSize="small" />, path: '/experts' },
      { label: 'Govt Schemes', labelHi: 'सरकारी योजनाएं', icon: <Policy fontSize="small" />, path: '/schemes' },
      { label: 'Pashupalan', labelHi: 'पशुपालन', icon: <Agriculture fontSize="small" />, path: '/livestock-advisory' },
    ]
  },
];

const SidebarItem = ({ item, collapsed, active }) => {
  const navigate = useNavigate();
  const { t, language } = useLanguage();
  const navKey = PATH_NAV_KEY[item.path];
  // Use translated label as primary; show English as secondary for non-English
  const primaryLabel  = (navKey && t.nav[navKey]) ? t.nav[navKey] : item.label;
  const secondaryLabel = language !== 'en' ? item.label : null;

  const btn = (
    <ListItemButton
      onClick={() => navigate(item.path)}
      sx={{
        borderRadius: '10px',
        mx: 1,
        mb: 0.3,
        background: active ? ACTIVE_BG : 'transparent',
        color: active ? PRIMARY : 'text.primary',
        borderLeft: active ? `3px solid ${PRIMARY}` : '3px solid transparent',
        '&:hover': {
          background: active ? ACTIVE_BG : 'rgba(46,125,50,0.06)',
          color: PRIMARY,
        },
        justifyContent: collapsed ? 'center' : 'flex-start',
        minHeight: 40,
        px: collapsed ? 1.5 : 1.5,
        transition: 'all 0.2s ease',
      }}
    >
      <ListItemIcon
        sx={{
          color: active ? PRIMARY : '#78909C',
          minWidth: collapsed ? 0 : 34,
          transition: 'color 0.2s',
        }}
      >
        {item.icon}
      </ListItemIcon>
      {!collapsed && (
        <ListItemText
          primary={primaryLabel}
          secondary={secondaryLabel}
          primaryTypographyProps={{
            fontSize: 13,
            fontWeight: active ? 700 : 500,
            lineHeight: 1.3,
            fontFamily: 'Poppins, sans-serif',
          }}
          secondaryTypographyProps={{
            fontSize: 10,
            color: active ? PRIMARY : 'text.disabled',
            lineHeight: 1.2,
            fontFamily: 'Poppins, sans-serif',
          }}
        />
      )}
    </ListItemButton>
  );

  return collapsed ? (
    <Tooltip title={`${item.label} · ${item.labelHi}`} placement="right" arrow>
      {btn}
    </Tooltip>
  ) : btn;
};

const Sidebar = ({ collapsed = false, onToggle, width = 240, collapsedWidth = 64 }) => {
  const location = useLocation();
  const { userProfile } = useAuth();
  const [openGroups, setOpenGroups] = useState({});

  const toggleGroup = (label) => {
    setOpenGroups(prev => ({ ...prev, [label]: !prev[label] }));
  };

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <Box
      sx={{
        width: collapsed ? collapsedWidth : width,
        flexShrink: 0,
        height: '100%',
        position: 'relative',
        bgcolor: '#FAFFFE',
        borderRight: '1px solid rgba(46,125,50,0.1)',
        overflowY: 'auto',
        overflowX: 'hidden',
        transition: 'width 0.28s cubic-bezier(0.4,0,0.2,1)',
        display: 'flex',
        flexDirection: 'column',
        '&::-webkit-scrollbar': { width: 3 },
        '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
        '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(46,125,50,0.2)', borderRadius: 4 },
        boxShadow: '2px 0 8px rgba(0,0,0,0.04)',
      }}
    >
      {/* ── Header: User profile + 3-dot toggle ─────── */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${PRIMARY_DARK} 0%, ${PRIMARY} 60%, #43A047 100%)`,
          px: 1.5,
          py: 1.5,
          display: 'flex',
          alignItems: 'center',
          gap: 1.2,
          position: 'relative',
          minHeight: 72,
          justifyContent: collapsed ? 'center' : 'flex-start',
        }}
      >
        <Avatar
          sx={{
            bgcolor: 'rgba(255,255,255,0.2)',
            border: '2px solid rgba(255,255,255,0.5)',
            width: 38,
            height: 38,
            fontSize: 15,
            fontWeight: 700,
            color: '#fff',
            flexShrink: 0,
          }}
        >
          {userProfile?.name?.[0]?.toUpperCase() || 'K'}
        </Avatar>

        {!collapsed && (
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="body2"
              fontWeight={700}
              noWrap
              sx={{ color: '#fff', fontSize: 13, lineHeight: 1.3 }}
            >
              {userProfile?.name || 'Kisan'}
            </Typography>
            <Typography
              variant="caption"
              noWrap
              sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 10, lineHeight: 1.2 }}
            >
              {userProfile?.district || 'FassalkartAI Farmer'}
            </Typography>
          </Box>
        )}

        {/* 3-dot collapse/expand toggle */}
        <Tooltip title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} placement="right" arrow>
          <IconButton
            size="small"
            onClick={onToggle}
            sx={{
              color: 'rgba(255,255,255,0.85)',
              bgcolor: 'rgba(255,255,255,0.1)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
              width: 28,
              height: 28,
              flexShrink: 0,
              ml: collapsed ? 0 : 'auto',
            }}
          >
            {collapsed ? <ChevronRight fontSize="small" /> : <MoreVert fontSize="small" />}
          </IconButton>
        </Tooltip>
      </Box>

      {/* ── Navigation Groups ────────────────────────── */}
      <List disablePadding sx={{ flex: 1, pt: 1 }}>
        {NAV_GROUPS.map((group) => {
          const isOpen = openGroups[group.label] !== false;
          return (
            <Box key={group.label}>
              {!collapsed && (
                <Box
                  sx={{
                    px: 2,
                    pt: 1.5,
                    pb: 0.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                  }}
                  onClick={() => toggleGroup(group.label)}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#90A4AE',
                      fontWeight: 700,
                      fontSize: '9.5px',
                      letterSpacing: '0.8px',
                      textTransform: 'uppercase',
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    {group.label}
                  </Typography>
                  {isOpen
                    ? <ExpandLess sx={{ fontSize: 14, color: '#90A4AE' }} />
                    : <ExpandMore sx={{ fontSize: 14, color: '#90A4AE' }} />
                  }
                </Box>
              )}

              <Collapse in={collapsed ? true : isOpen} timeout="auto">
                {group.items.map(item => (
                  <SidebarItem
                    key={item.path}
                    item={item}
                    collapsed={collapsed}
                    active={isActive(item.path)}
                  />
                ))}
              </Collapse>

              {!collapsed && (
                <Divider sx={{ mx: 2, my: 0.5, borderColor: 'rgba(46,125,50,0.08)' }} />
              )}
            </Box>
          );
        })}
      </List>

      {/* ── Footer ───────────────────────────────────── */}
      {!collapsed && (
        <Box
          sx={{
            px: 2,
            py: 1.5,
            borderTop: '1px solid rgba(46,125,50,0.1)',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: '#4CAF50',
              boxShadow: '0 0 6px #4CAF50',
            }}
          />
          <Typography
            variant="caption"
            sx={{ color: '#90A4AE', fontSize: '10px', fontFamily: 'Poppins, sans-serif' }}
          >
            FassalkartAI v1.0 · Beta
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Sidebar;
